















import Vue from 'vue';
import SettingForm, {
  FormDataInterface,
} from '@/containers/cv-setting/form.vue';
import * as CvSettingStore from '@/containers/cv-setting/store';
import { Cv, UpdateCvRequestPublishTypeEnum } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SettingForm,
  },
  props: {
    cv: {
      type: Object as () => Cv,
      required: true,
    },
  },
  methods: {
    async onSubmit({
      title,
      publish_type,
      original_path,
      password,
      password_confirmation,
      publish_date,
    }: FormDataInterface) {
      const { id } = this.cv;
      await this.$store.dispatch(
        CvSettingStore.UpdateCv.namespaced({
          params: { id },
          body: {
            title,
            // FIXME avoid using any
            publish_type: publish_type as any,
            original_path,
            password,
            password_confirmation,
            publish_date,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { id } = this.cv;
      await this.$store.dispatch(
        CvSettingStore.DeleteCv.namespaced({ params: { id } })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      this.$router.push({ name: 'cvs_path' });
    },
  },
});
